module.exports = "https://static.moomoo.com/components/common-redpacket/images/bg.f8c04bf249.png";